import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import SearchOptions from "datalign-module-template/models/search-options";
import { useEasierTheme } from "datalign-themes";
import React from "react";

const BaseSortBy = ({
  searchOptions,
  onOptionsChange,
}: {
  searchOptions: SearchOptions;
  onOptionsChange: (searchOptions: SearchOptions) => void;
}) => {
  const easierTheme = useEasierTheme();
  return (
    <Box
      display="flex"
      flexWrap="wrap"
      columnGap={1}
      rowGap={1}
      sx={{ minWidth: 0 }} // helps prevent overflow
    >
      <FormControl variant="outlined" size="small">
        <InputLabel id="sort-label">Sort by</InputLabel>
        <Select
          labelId="sort-label"
          id="sort-select"
          variant="outlined"
          size="small"
          value={searchOptions.order_by.column_name}
          label="Sort by"
          onChange={(event) =>
            onOptionsChange({
              ...searchOptions,
              order_by: {
                ...searchOptions.order_by,
                column_name: event.target.value,
              },
            })
          }
          disableUnderline
          sx={{
            background: easierTheme?.Colour.SurfaceContainerLow(),
            borderRadius: "12px",
          }}
        >
          <MenuItem value="title">Title</MenuItem>
          <MenuItem value="updated_at">Updated at</MenuItem>
          <MenuItem value="created_at">Registered at</MenuItem>
        </Select>
      </FormControl>
      <FormControl variant="outlined" size="small">
        <InputLabel id="order-label">Order by</InputLabel>
        <Select
          labelId="order-label"
          id="order-select"
          value={searchOptions.order_by.order}
          label="Order by"
          onChange={(event) =>
            onOptionsChange({
              ...searchOptions,
              order_by: {
                ...searchOptions.order_by,
                order: event.target.value,
              },
            })
          }
          sx={{
            background: easierTheme?.Colour.SurfaceContainerLow(),
            borderRadius: "12px",
          }}
          disableUnderline
          variant="outlined"
          size="small"
        >
          <MenuItem value="asc">Ascending</MenuItem>
          <MenuItem value="desc">Descending</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default BaseSortBy;
